/* eslint-disable indent */

import { getReceiptReviewMissionCardClickArea, ReceiptReviewMissionCardGuide } from './ReceiptReviewMissionCard.helper'
import ReceiptReviewMissionCardContent from './ReceiptReviewMissionCardContent'
import CompletedMissionCard from '../../MissionCard/CompletedMissionCard'
import { MissionCard, MissionCardProps } from '../../MissionCard/MissionCard'
import ProgressMissionCard from '../../MissionCard/ProgressMissionCard'

interface Props {
  missionCard: MissionCardProps
}

const ReceiptReviewMissionCard = ({ missionCard }: Props) => {
  const stepIndex = MissionCard.getCurrentStepIndex(missionCard)
  const step = stepIndex ? stepIndex + 1 : undefined

  const nClickArea = getReceiptReviewMissionCardClickArea(missionCard)

  const Content = <ReceiptReviewMissionCardContent missionCard={missionCard} />

  if (MissionCard.isCompleteMission(missionCard)) {
    return (
      <CompletedMissionCard missionCard={missionCard} foldable Content={Content} step={step} nClickArea={nClickArea} />
    )
  }

  return (
    <ProgressMissionCard
      missionCard={missionCard}
      Content={Content}
      Guide={<ReceiptReviewMissionCardGuide missionCard={missionCard} />}
      step={step}
      nClickArea={nClickArea}
    />
  )
}

export default ReceiptReviewMissionCard
